<template>
  <div>
    <el-dialog
      :visible.sync="visible"
      :before-close="close"
      title="预警处理"
    >
    <Form :label-width="120" label-colon>
          
          <FormItem label="客户头像">
            <div class="avatar-wrapper">
              <img :src="detail.avatar" class="avatar" />
            </div>
          </FormItem>
          <FormItem label="预警信息"><span class="">{{ detail.warningName }}:{{ detail.description }}</span></FormItem>
          <FormItem label="预警时间">{{ detail.warningTime }}</FormItem>
          <FormItem v-if="detail.processFlowDesc" label="处理过程">{{ detail.processFlowDesc }}</FormItem>
          <FormItem v-if="detail.process&&detail.process.edit" label="建议">
            <Input v-model="suggestion" type="textarea" :rows="4" placeholder="请输入建议" autofocus/>
          </FormItem>
          <div class="lu-footer" v-if="detail.process">
            <Button class="send-btn" @click="close">关闭</Button>
            <Button v-for="action in detail.process.actions" :key="action.title" type="primary" class="send-btn" @click="doAction(action)">{{ action.title }}</Button>
          </div>
    </Form>
    </el-dialog>
    <el-dialog
      :visible.sync="applyHelp.visible"
      :before-close="applyHelpClose"
      append-to-body
      title="温馨提示"
      width="300px"
    >
    <Form label-colon>
          
          <div v-if="detail.process" class="alert-content">
            {{ detail.process.applyAlert }}
          </div>
          <FormItem>
            <Input v-model="applyHelpReason" type="textarea" :rows="4" placeholder="请输入原因" autofocus/>
          </FormItem>
          <div class="lu-footer">
            <Button class="send-btn" @click="applyHelpClose">取消</Button>
            <Button type="primary" class="send-btn" @click="doApplyHelp">提交</Button>
          </div>
    </Form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "",
  props:['visible','detail'],
  data() {
    return {
      suggestion:"",
      applyHelpReason:"",
      applyHelp:{
        visible:false
      }
    };
  },
  created() {
    var that=this;
    that.$watch('visible', function() {
       console.log('detail',this.detail);
       that.initdata();
    });
  },
  methods: {
    initdata(){
      this.suggestion='';
      this.applyHelpReason='';
    },
    close(){
      console.log('detail',this.detail);
      this.$emit("close");
    },
    submit(){
      var that = this;
      if(!that.suggestion){
        this.$message({
          showClose: true,
          message: "处理建议不能为空",
          type: "warning",
          center: true,
        });
        return;
      }
      this.$confirm("您确定要提交么?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var param={
            id:that.detail.id,
            suggestion:that.suggestion
          }
          that.api.warningUpdate(param).then((response) => {
            response = response.data;
            if (response.code == 0) {
              that.close();
              this.notificationCenter.postNotificationName('warningRecordListRefresh');
            }
            else{
              this.$message({
              showClose: true,
              message: response.msg,
              type: "warning",
              center: true,
            });
            }
          });
          
        })
        .catch(() => {});
    },
    doAction(action){
      if(action.id=='apply'){
        this.applyForHelp();
      }
      else if(action.id=='submit'){
        this.submit();
      }
    },
    applyForHelp(){
      this.applyHelp.visible=true;
    },
    applyHelpClose(){
      this.applyHelp.visible=false;
    },
    
    doApplyHelp(){
      var that=this;
      if(!that.applyHelpReason){
        this.$message({
          showClose: true,
          message: "请填写申请业务帮助原因",
          type: "warning",
          center: true,
        });
        return;
      }
      var param={
        id:that.detail.id,
        reason:that.applyHelpReason
      }
      that.api.warningTransfer(param).then((response) => {
        response = response.data;
        if (response.code == 0) {
          that.applyHelpClose();
          that.close();
          this.notificationCenter.postNotificationName('warningRecordListRefresh');
        }
        else{
          this.$message({
          showClose: true,
          message: response.msg,
          type: "warning",
          center: true,
        });
        }
      });
    },
    openZSFADetail(){
      this.notificationCenter.postNotificationName('openZsfaDetailDailog',this.detail);
    }
  },
};
</script>
<style lang="less" scoped="scoped">
.alert-content{
  margin-bottom: 30px;
}

.avatar{
  width: 50px;
}
.avatar-wrapper{
  display: flex;
  align-items: center;
}
</style>
